module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/uYryvC/tc-custom/9781426879234.jpg?1701950712702",
      "alt": "This image is the cover for the book Annie and the Red-Hot Italian, The Balfour Brides"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Annie and the Red-Hot Italian, The Balfour Brides\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Annie is a single mother who adores her young sonbut as one of the notorious Balfour heiresses, she will have to work hard to give her baby a normal childhood. Then a chance meeting forces her back into the world of Luca de Salvatore, the gorgeous father of her child!"), _c('br'), _c('br'), _vm._v("Luca doesn't know that he has a son. Annie has to tell him, but Luca can't see past her spoiled and scandalous Balfour reputation. Can Annie find a way to make Luca understandand let her little boy know his father?"), _c('br'), _c('br')]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Carole Mortimer\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Carole Mortimer was born in England, the youngest of three children. She began writing in 1978, and has now written over one hundred and seventy books for Harlequin Mills and Boon®. Carole has six sons, Matthew, Joshua, Timothy, Michael, David and Peter. She says, ‘I’m happily married to Peter senior; we’re best friends as well as lovers, which is probably the best recipe for a successful relationship. We live in a lovely part of England.’")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0